import {
    buildErrorsFromMsgs,
    buildErrorsFromResponse
} from '../../../core/js/utils/errorHandling';

export const CHECK_GIFT_CARD_BALANCE = 'CHECK_GIFT_CARD_BALANCE';
export const UPDATE_GIFT_CARD_BALANCE = 'UPDATE_GIFT_CARD_BALANCE';
export const GIFT_CARD_DATA = 'GIFT_CARD_DATA';
export const GIFT_CARD_ERROR = 'GIFT_CARD_ERROR';
export const SUBMIT_CONTACT_US_FORM = 'SUBMIT_CONTACT_US_FORM';
export const CONTACT_US_FORM_SUCCESS = 'CONTACT_US_FORM_SUCCESS';
export const CONTACT_US_FORM_ERROR = 'CONTACT_US_FORM_ERROR';
export const CONTACT_US_DATA = 'CONTACT_US_DATA';
export const CHANGE_SELECTED_INTL_SHIPPING_COUNTRY = 'CHANGE_SELECTED_INTL_SHIPPING_COUNTRY';
export const CHANGE_STYLIST_PREFERRED_LOCATION = 'CHANGE_STYLIST_PREFERRED_LOCATION';
export const CHANGE_STYLE_PREFERENCE = 'CHANGE_STYLE_PREFERENCE';
export const CHANGE_APPOINTMENT_TYPE = 'CHANGE_APPOINTMENT_TYPE';
export const CHANGE_HOME_TYPE = 'CHANGE_HOME_TYPE';
export const CHANGE_ROOM_PREFERENCE = 'CHANGE_ROOM_PREFERENCE';
export const CHANGE_MONTH_FOR_PREFERRED_FIRST_CHOICE = 'CHANGE_MONTH_FOR_PREFERRED_FIRST_CHOICE';
export const CHANGE_DAY_FOR_PREFERRED_FIRST_CHOICE = 'CHANGE_DAY_FOR_PREFERRED_FIRST_CHOICE';
export const CHANGE_TIME_FOR_PREFERRED_FIRST_CHOICE = 'CHANGE_TIME_FOR_PREFERRED_FIRST_CHOICE';
export const CHANGE_MONTH_FOR_PREFERRED_SECOND_CHOICE = 'CHANGE_MONTH_FOR_PREFERRED_SECOND_CHOICE';
export const CHANGE_TIME_FOR_PREFERRED_SECOND_CHOICE = 'CHANGE_TIME_FOR_PREFERRED_SECOND_CHOICE';
export const CHANGE_DAY_FOR_PREFERRED_SECOND_CHOICE = 'CHANGE_DAY_FOR_PREFERRED_SECOND_CHOICE';
export const SET_STORES_FOR_PERSONAL_SHOPPER = 'SET_STORES_FOR_PERSONAL_SHOPPER';
export const SET_EMAIL_FOR_PERSONAL_SHOPPER = 'SET_EMAIL_FOR_PERSONAL_SHOPPER';
export const SET_EMAIL_FOR_PERSONAL_SHOPPER_STORE = 'SET_EMAIL_FOR_PERSONAL_SHOPPER_STORE';
export const SET_EMAIL_FOR_PERSONAL_SHOPPER_HOME_STYLIST = 'SET_EMAIL_FOR_PERSONAL_SHOPPER_HOME_STYLIST';
export const CREATE_UNSUBSCRIBE_DATA = 'CREATE_UNSUBSCRIBE_DATA';
export const EMAIL_UNSUBSCRIBE = 'EMAIL_UNSUBSCRIBE';
export const EMAIL_UNSUBSCRIBE_SUCCESS = 'EMAIL_UNSUBSCRIBE_SUCCESS';
export const EMAIL_UNSUBSCRIBE_ERROR = 'EMAIL_UNSUBSCRIBE_ERROR';
export const SAVE_EMAIL_SIGN_UP_DATA = 'SAVE_EMAIL_SIGN_UP_DATA';
export const SIGN_UP_FOR_EMAIL_SUCCESS = 'SIGN_UP_FOR_EMAIL_SUCCESS';
export const SIGN_UP_FOR_EMAIL_ERROR = 'SIGN_UP_FOR_EMAIL_ERROR';
export const SELECT_CONTACT_US_HELP_TOPIC = 'SELECT_CONTACT_US_HELP_TOPIC';

/*
 * Fired when a user clicks check balance on gift card balance form
 * @param {String} cardNumber - the gift card number
 * @param {String} pin - the gift card pin
 * @return {Object} FSA
 */
export function checkGiftCardBalance(cardNumber, pin, token) {
    return {
        type: CHECK_GIFT_CARD_BALANCE,
        payload: {
            cardNumber: cardNumber,
            pin: pin,
            recaptchaToken: token
        }
    };
}

/*
 * Fired when user changes their selected country for international shipping info
 * @param {Object} country - the selected country
 * @return {Object} FSA
 */
export function changeSelectedIntlShippingCountry(country) {
    return {
        type: CHANGE_SELECTED_INTL_SHIPPING_COUNTRY,
        payload: {
            country: country
        }
    };
}

/*
 * Fired when giftCardBalanceSaga completes
 * @param {String} amount - the gift card balance
 * @return {Object} FSA
 */
export function updateGiftCardBalance(amount, currencyInfo) {
    return {
        type: UPDATE_GIFT_CARD_BALANCE,
        payload: {
            amount: amount,
            currencyInfo: currencyInfo
        }
    };
}

/**
 * Gift card form data
 * @param {object} formData Map of the form data
 * @param {array} msgs List of error messages on the form (on client-side validation)
 * @param {array} previousMsgs List of previous error messages on the form (on client-side validation).
 * @returns {object} FSA
 */
export function giftCardFormData(formData, msgs, previousMsgs) {
    const convertedMsgs = buildErrorsFromMsgs(msgs);
    const redraw = JSON.stringify(previousMsgs) !== JSON.stringify(convertedMsgs);

    return {
        type: GIFT_CARD_DATA,
        payload: {
            data: formData,
            messages: convertedMsgs,
            redraw: redraw
        }
    };
}

/*
 * Fired when giftCardBalanceSaga completes with an error
 * @param {object} response The gift card saga error response object
 * @return {Object} FSA
 */
export function giftCardError(response) {
    const payload = buildErrorsFromResponse(response);

    return {
        type: GIFT_CARD_ERROR,
        payload: payload
    };
}

export function submitContactUsForm(formData) {
    return {
        type: SUBMIT_CONTACT_US_FORM,
        payload: {
            data: formData
        }
    };
}

export function contactUsFormSuccess(res) {
    return {
        type: CONTACT_US_FORM_SUCCESS,
        payload: {
            response: res
        }
    };
}

export function contactUsFormError(error) {
    return {
        type: CONTACT_US_FORM_ERROR,
        error: true,
        payload: {
            response: error
        }
    };
}

export function contactUsData(formData, msgs) {
    const convertedMsgs = buildErrorsFromMsgs(msgs);

    return {
        type: CONTACT_US_DATA,
        payload: {
            data: formData,
            msgs: convertedMsgs
        }
    };
}

export function selectContactUsHelpTopic(helpTopic) {
    return {
        type: SELECT_CONTACT_US_HELP_TOPIC,
        payload: {
            helpTopic: helpTopic
        }
    };
}

export function changeStylistPreferredLocation(preferredLocation) {
    return {
        type: CHANGE_STYLIST_PREFERRED_LOCATION,
        payload: {
            preferredLocation: preferredLocation
        }
    };
}

export function changeStylePreference(stylePreference) {
    return {
        type: CHANGE_STYLE_PREFERENCE,
        payload: {
            stylePreference: stylePreference
        }
    };
}

export function changeAppointmentType(appointmentType) {
    return {
        type: CHANGE_APPOINTMENT_TYPE,
        payload: {
            appointmentType: appointmentType
        }
    };
}

export function changeHomeType(homeType) {
    return {
        type: CHANGE_HOME_TYPE,
        payload: {
            homeType: homeType
        }
    };
}

export function changeRoomPreference(roomPreference) {
    return {
        type: CHANGE_ROOM_PREFERENCE,
        payload: {
            roomPreference: roomPreference
        }
    };
}

export function setMonthForPreferredFirstChoice(month) {
    return {
        type: CHANGE_MONTH_FOR_PREFERRED_FIRST_CHOICE,
        payload: {
            firstChoiceMonth: month
        }
    };
}

export function setDayForPreferredFirstChoice(day) {
    return {
        type: CHANGE_DAY_FOR_PREFERRED_FIRST_CHOICE,
        payload: {
            firstChoiceDay: day
        }
    };
}

export function setTimeForPreferredFirstChoice(time) {
    return {
        type: CHANGE_TIME_FOR_PREFERRED_FIRST_CHOICE,
        payload: {
            firstChoiceTime: time
        }
    };
}

export function setMonthForPreferredSecondChoice(month) {
    return {
        type: CHANGE_MONTH_FOR_PREFERRED_SECOND_CHOICE,
        payload: {
            secondChoiceMonth: month
        }
    };
}

export function setDayForPreferredSecondChoice(day) {
    return {
        type: CHANGE_DAY_FOR_PREFERRED_SECOND_CHOICE,
        payload: {
            secondChoiceDay: day
        }
    };
}

export function setTimeForPreferredSecondChoice(time) {
    return {
        type: CHANGE_TIME_FOR_PREFERRED_SECOND_CHOICE,
        payload: {
            secondChoiceTime: time
        }
    };
}

export function setStoresForPersonalShopper(stores) {
    return {
        type: SET_STORES_FOR_PERSONAL_SHOPPER,
        payload: {
            storesForPersonalShopper: stores
        }
    };
}

export function setStylistEmailAddress(email) {
    return {
        type: SET_EMAIL_FOR_PERSONAL_SHOPPER,
        payload: {
            stylistEmail: email
        }
    };
}

export function setStylistLocationEmailAddress(email) {
    return {
        type: SET_EMAIL_FOR_PERSONAL_SHOPPER_STORE,
        payload: {
            storeEmail: email
        }
    };
}

export function setHomeStylistEmailAddress(email) {
    return {
        type: SET_EMAIL_FOR_PERSONAL_SHOPPER_HOME_STYLIST,
        payload: {
            homeStylistEmail: email
        }
    };
}

export function createUnsubscribeData(formData, msgs) {
    const convertedMsgs = buildErrorsFromMsgs(msgs);

    return {
        type: CREATE_UNSUBSCRIBE_DATA,
        payload: {
            create: {
                data: formData,
                msgs: convertedMsgs
            }
        }
    };
}

export function submitEmailUnsubscribe(email) {
    return {
        type: EMAIL_UNSUBSCRIBE,
        payload: {
            email: email
        }
    };
}

export function emailUnsubscribeSuccess(email) {
    return {
        type: EMAIL_UNSUBSCRIBE_SUCCESS,
        payload: {
            email: email
        }
    };
}

export function emailUnsubscribeError(errorResponse) {
    return {
        type: EMAIL_UNSUBSCRIBE_ERROR,
        payload: errorResponse
    };
}

export function saveEmailSignUpData(formData) {
    return {
        type: SAVE_EMAIL_SIGN_UP_DATA,
        payload: {
            formData: formData
        }
    };
}

export function signUpForEmailSuccess(formData) {
    return {
        type: SIGN_UP_FOR_EMAIL_SUCCESS,
        payload: {
            formData: formData
        }
    };
}

export function signUpForEmailError(err) {
    return {
        type: SIGN_UP_FOR_EMAIL_ERROR,
        payload: {
            error: err
        }
    };
}

/*
 * Fired when user changes their selected country for international shipping info
 * @param {Object} country - the selected country
 * @return {Object} FSA
 */
export function changeContactUsSubject(country) {
    return {
        type: CHANGE_SELECTED_INTL_SHIPPING_COUNTRY,
        payload: {
            country: country
        }
    };
}
